import type { Exam, LearningFocus } from '@mastery/api-client-web';

export function focusURL(
  focus: Pick<LearningFocus, 'exam_code' | 'section' | 'part' | 'topic'>,
  adaptive = true,
) {
  const params = new URLSearchParams({ exam: focus.exam_code });
  if (focus.section) params.set('section', focus.section);
  if (focus.part) params.set('part', String(focus.part));
  if (focus.topic) params.set('topic', focus.topic);
  if (adaptive) params.set('adaptive', '1');
  return '/practice?' + params;
}

export function focusTitle(f: LearningFocus, exams: Exam[]) {
  const section = exams
    .find((e) => e.code === f.exam_code)
    ?.sections.find((s) => s.code === f.section);
  const part = section?.parts.find((p) => p.number === f.part);
  if (f.dimension === 'topic') return f.topic;
  return `${section?.name ?? f.section} · Part ${f.part}${f.topic ? ' · ' + f.topic : ''}${part ? '｜' + part.label : ''}`;
}

export function priorityFocus(profile: LearningFocus[]) {
  const weak = profile.filter((f) => f.state === 'needs_practice');
  return (
    weak.find(
      (f) =>
        f.dimension === 'intersection' &&
        ['part', 'topic', 'intersection'].includes(f.interpretation),
    ) ??
    weak.find((f) => f.dimension === 'part') ??
    weak[0]
  );
}

export function trainingURL(focus: LearningFocus) {
  if (focus.dimension === 'intersection' && focus.interpretation === 'topic')
    return focusURL({ ...focus, section: '', part: 0 });
  if (focus.dimension === 'intersection' && focus.interpretation === 'part')
    return focusURL({ ...focus, topic: '' });
  return focusURL(focus);
}

export type ExplanationPart = { title: string; text: string };
export function explanationParts(text: string): ExplanationPart[] {
  const headings: Record<string, string> = {
    题意: '句意理解',
    句意: '句意理解',
    句意理解: '句意理解',
    解析: '题目分析',
    分析: '题目分析',
    题目分析: '题目分析',
    考点: '核心考点',
    知识点: '核心考点',
    易错点: '易错提醒',
  };
  const result: ExplanationPart[] = [];
  for (const paragraph of text.split(/\n\s*\n/).filter((v) => v.trim())) {
    const match = paragraph.match(
      /^(题意|句意理解|句意|题目分析|解析|分析|知识点|考点|易错点)[：:]\s*([\s\S]*)$/,
    );
    result.push(
      match
        ? { title: headings[match[1]], text: match[2] }
        : { title: '题目分析', text: paragraph },
    );
  }
  return result;
}
